import React, { useEffect, useState } from 'react';
import styles from './register.module.css'
import StepOne from '../../../Component/Auth/Register/stepOne'
import StepTwo from '../../../Component/Auth/Register/stepTwo'
import Loader from '../../../Component/Common/Loader/index'


import { register } from '../../../action/auth';

import { toast } from 'react-toastify';
import { getsessionStorage, removeAllSessionStorage, removeStorage, setsessionStorage } from '../../../utils';
import constant from '../../../constant';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import StepThree from '../../../Component/Auth/Register/stepThree';
import StepFour from '../../../Component/Auth/Register/stepFour';

const Register = () => {
    const history = useHistory()
    const [step, setStep] = useState(1);
    useEffect(() => {
        const storage = getsessionStorage(constant.keys.registration_ref);
        if (storage) {
            try {
                setStep(storage.step);
            } catch (error) {
                console.error("Failed to parse registration_ref:", error);
            }
        }
    }, [])
    const [showLoader, setShowLoader] = useState(false)

    const nextStep = () => setStep(step + 1);
    const prevStep = () => {
        if (step === 3) {
            setStep(1); // Skip Step 2 and go directly to Step 1
        } else if (step > 1) {
            setStep(step - 1); // Normal decrement for other steps
        }
    };

    const onSubmit = async (payload) => {
        try {
            const storage = getsessionStorage(constant.keys.registration_ref);
            setShowLoader(true);

            const res = await register(payload, step);

            if (res.status) {
                if (step === 1) {
                    setsessionStorage(constant.keys.registration_ref, { step: 2, ref_code: res.result.ref_code });
                    nextStep();
                } else if (step === 2) {
                    setsessionStorage(constant.keys.registration_ref, { step: 3, ref_code: btoa(JSON.stringify({ mobile: res.result.mobile })) });
                    nextStep();
                } else if (step === 3) {
                    const obj = {
                        company_category: res.result.company_category,
                        company_name: res.result.company_name,
                        industry: res.result.industry,
                        pin_code: res.result.pin_code,
                        gst: res.result.gst,
                        mobile: JSON.parse(atob(storage.ref_code)).mobile
                    };
                    setsessionStorage(constant.keys.registration_ref, { step: 4, ref_code: btoa(JSON.stringify(obj)) });
                    nextStep();
                } else if (step === 4) {
                    removeAllSessionStorage();
                    history.push(constant.component.dashboard.url);
                }
            } else {
                toast.error(res.error);
            }
        } catch (error) {
            console.error("Error in onSubmit:", error);
            toast.error("Something went wrong! Please try again.");
        } finally {
            setShowLoader(false);
        }
    };

    return (
        <React.Fragment>
            {showLoader && <Loader />}
            <section className={`${styles['register-bg']}`}>
                <div className='row h-100'>
                    <div className='container'>
                        <div className='col-md-12 h-100 d-flex justify-content-center align-items-center'>
                            {step === 1 && (
                                <StepOne
                                    onSubmit={onSubmit}
                                />
                            )}

                            {step === 2 && (
                                <StepTwo
                                    onSubmit={onSubmit}
                                />


                            )}

                            {step === 3 && (
                                <StepThree
                                    onSubmit={onSubmit}
                                    prevStep={prevStep}
                                />
                            )}

                            {step === 4 && (
                                <StepFour
                                    onSubmit={onSubmit}
                                    prevStep={prevStep}

                                />
                            )}

                            {step === 5 && (
                                <div className={`${styles['final-box']} card`}>
                                    <div className={`${styles['final-body']} card-body text-center`}>
                                        <h5 className={`${styles['reg-title']}`}>Thanks for Registration</h5>
                                        <p className={`${styles['reg-text']}`}>Enter your company's details to complete registration.</p>
                                    </div>
                                </div>
                            )}

                            {/* {step > 1 && step < 5 && (
                        <button className="btn btn-secondary mt-3" onClick={prevStep}>Back</button>
                      )} */}
                        </div>
                    </div>
                </div>
            </section>
        </React.Fragment>

    )
}

export default Register